<div class="container modal-update">
    <div class="container">
        <h3>Change Password</h3>
    </div>
    <div class="row form-content">
        <form class="form" [formGroup]="form" (ngSubmit)="changePassword()">
            <div class="row">
                <div class="col">
                    <div class="form-item">
                        <label>Username <span class="text-danger">*</span></label>
                    </div>
                    <div class="input-container-box form-item">
                        <input type="text" class="form-control input-field disabled" formControlName="username" disabled>
                    </div>
                </div>
                <div class="col">
                    <div class="form-item">
                        <label>Current Password <span class="text-danger">*</span></label>
                    </div>
                    <div class="input-container-box form-item">
                        <input type="password" class="form-control input-field" formControlName="oldPassword" placeholder="Enter Current Password" >
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-item-msg text-danger" *ngIf="form.controls.username.touched && form.controls.username.errors && form.controls.username.errors.required" >
                        Username is required
                    </div>
                </div>
                <div class="col">
                    <div class="form-item-msg text-danger" *ngIf="form.controls.oldPassword.touched && form.controls.oldPassword.errors && form.controls.oldPassword.errors.required" >
                        Current Password is required
                    </div>
                </div>
            </div>
            <div class="row row-separation">
                <div class="col">
                    <div class="form-item">
                        <label>Password <span class="text-danger">*</span></label>
                    </div>
                    <div class="input-container-box form-item">
                        <input type="password" class="form-control input-field" formControlName="newPassword" placeholder="Enter New Password" >
                    </div>
                </div>
                <div class="col">
                    <div class="form-item">
                        <label>Confirm Password <span class="text-danger">*</span></label>
                    </div>
                    <div class="input-container-box form-item">
                        <input type="password" class="form-control input-field" formControlName="confirmNewPassword" placeholder="Confirm New Password" >
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-item-msg text-danger" *ngIf="form.controls.newPassword.touched && form.controls.newPassword.errors && form.controls.newPassword.errors.required" >
                        Password is required
                    </div>
                </div>
                <div class="col">
                    <div class="form-item-msg text-danger" *ngIf="form.controls.confirmNewPassword.touched && form.controls.confirmNewPassword.errors && form.controls.confirmNewPassword.errors.required">
                        Confirm Password is required
                    </div>
                </div>
            </div>
            <div class="row text-danger form-item-msg" *ngIf="form.controls.newPassword.touched && form.controls.newPassword.errors == null 
            && form.controls.oldPassword.touched && form.controls.oldPassword.errors == null 
            && form.hasError('samePassword')">
                New Password cannot be Current Password
            </div>
            <div class="row text-danger form-item-msg" *ngIf="form.controls.newPassword.touched && form.controls.newPassword.errors == null 
            && form.controls.confirmNewPassword.touched && form.controls.confirmNewPassword.errors == null 
            && form.hasError('notMatched')">
                Passwords are not matched
            </div>
            <div class="row-separation form-item" [ngClass]="{'text-danger': checkPasswordValidations(), 'text-light': !checkPasswordValidations()}">
                Password must contain Min 1 Uppercase letter, Min 1 Lowercase letter, Min 1 Number, Min 1 Special character, Min 8 Characters.
            </div>
            <div class="row-buttons">
                <button class="btn btn-cancel" [disabled]="loading" type="button" (click)="cancel()">Close</button>
                <button class="btn btn-submit" type="submit" [disabled]="loading || !form.valid">Save</button>   
            </div>
            <div *ngIf="error" class="row text-danger">{{error}}</div>
        </form>
    </div>
    
    
</div>
